import { inject, Injectable } from '@angular/core';
import { BaseModel } from '../models/basemodel';
import { AbstractDataService } from './abstractdata.service';
import { DataTableModuleConfiguration } from './datatable-module.config';

@Injectable({ providedIn: 'root' })
export class WorkflowDataService<T extends BaseModel> extends AbstractDataService<T> {
  constructor() {
    const configuration = inject(DataTableModuleConfiguration);
    super(`${configuration.apiUrls.workflow}/api/v1`);
    if (!this.configuration.apiUrls.workflow) {
      throw new Error('Workflow API URL is not configured');
    }
  }
}
